import * as React from "react";
import { GridRowLessTwoBox } from "./styles";
import DoubleSwipe from "./doubleSwipe";
import { ProductCard } from "../../NormalProducts/ProductCard";
import { getCellWidthByGrid as getProductCardPosterWidth } from "../../../utils/size";
class SwipeProduct extends React.Component {
    constructor() {
        super(...arguments);
        this.productsOnOnePage = (this.props.gridCol || 4) * 2;
        this.state = {
            cIndex: 0,
            animationDuration: 0,
            needAdd: Math.ceil((this.productsOnOnePage * 3) / 2),
        };
        this.getOffset = () => {
            const { products } = this.props;
            return Math.floor(products.length / this.productsOnOnePage) * this.productsOnOnePage;
        };
        this.renderCard = (product, index) => {
            const { gridCol, gridGap, gridWidth: width, posterRatio, layoutStyle, placeholderBg, scoreOptions, smartImageProps, onClick, poolId, } = this.props;
            const productCardWidth = getProductCardPosterWidth({
                contentWidth: width,
                gridCol,
                gridGap,
            });
            return (React.createElement(ProductCard, { poolId: poolId, key: index, product: Object.assign({}, product), width: `${productCardWidth}px`, posterRatio: posterRatio, gridCol: gridCol, smartImageProps: smartImageProps, onClick: () => onClick && onClick((index + 1).toString(), product.gpid), layoutStyle: layoutStyle, placeholderBg: placeholderBg, collectOptions: scoreOptions }));
        };
    }
    render() {
        const { gridCol = 4, gridGap = 12, id, products, gridWidth, posterRatio, scoreOptions, handWheel, poolId, } = this.props;
        const productCardWidth = getProductCardPosterWidth({
            contentWidth: gridWidth,
            gridCol,
            gridGap,
        });
        const productCardPosterHight = +productCardWidth * +posterRatio;
        if (products.length <= this.productsOnOnePage) {
            return (React.createElement(GridRowLessTwoBox, { posterHeight: productCardPosterHight, gridCol: gridCol, gridGap: gridGap, cardWidth: productCardWidth, gridWidth: gridWidth }, products.map((product, index) => this.renderCard(product, index))));
        }
        return (React.createElement(DoubleSwipe, { products: products, posterHeight: productCardPosterHight, gridCol: gridCol, gridGap: gridGap, cardWidth: productCardWidth, gridWidth: gridWidth, posterRatio: posterRatio, id: id, scoreOptions: scoreOptions, handWheel: handWheel, onClick: this.props.onClick, onClickBack: this.props.onClickBack, onClickNext: this.props.onClickNext, layoutStyle: this.props.layoutStyle, placeholderBg: this.props.placeholderBg, poolId: poolId }));
    }
}
export default SwipeProduct;
